import { render } from "./GetInvolvedView.vue?vue&type=template&id=ae44f47a&scoped=true"
const script = {}

import "./GetInvolvedView.vue?vue&type=style&index=0&id=ae44f47a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae44f47a"]])

export default __exports__